
import {initWebComponent} from "@/helpers/web-component-helper";

export class HeaderButtonComponent extends HTMLElement {
    constructor(){
        super();

        const tooltip = this.getAttribute('data-tooltip')
        let title = this.getAttribute('data-title')
        const icon = this.getAttribute('data-icon')
        const disabled = this.getAttribute('data-disabled')
        const dropdownToggle = this.getAttribute('data-dropdown-toggle')

        let btnDisabled = ''
        if(disabled === "true") {
            btnDisabled = 'btn-disabled'
        }

        if(title !== null) {

            let style = 'margin-left:25px'
            if(icon.includes('fi')) {
                style = 'margin-left:30px'
            }

            // title = '<div class="d-block-inline ' + btnDisabled + '" style="font-size:17px;margin-top:-25px;' + style + '">' +
            //     ' <layout-language data-key="' + title + '"></layout-language>' +
            //     '</div>'
        } else {
            title = ''
        }

        let popperHeader = ''
        if(tooltip) {
            popperHeader = 'popper-header'
        }

        const template = document.createElement('template');
       //  let innerHTML = ``
       //  innerHTML += `<div class="nav-item"><a class="nav-link ` + popperHeader + `" href="#">
       //        <span class="` + icon + ` navbar-icon ` + btnDisabled + `"></span>`
       //
       //  innerHTML += `

       //
       //
       // innerHTML += `
       //        ` + title + `
       //      </a>`;

       // innerHTML += `</div>`;
        let innerHTML = `
        <button  data-test="header_button" class="btn btn-outline-secondary btn-sm borderless ${popperHeader} text-transform-none" ${dropdownToggle}>
            <span class="${icon} navbar-icon ${btnDisabled}"></span>
            <div class="popper-tooltip" role="tooltip">
                 <layout-language data-key="${tooltip}"></layout-language>
                <div class="arrow" data-popper-arrow></div>
             </div>
        </button>`

       template.innerHTML = innerHTML

        initWebComponent(this, template)
    }
}

